import { matchPath, useLocation } from "react-router-dom";

import { ModalRoute } from "../Navigation/ModalRoute";
import { ModalTransitionSwitch } from "../Navigation/ModalTransitionSwitch";
import { ShiftDiscoveryFavoriteWorkplacesModal } from "./FavoriteWorkplaces/Modal";
import { SHIFT_DISCOVERY_FAVORITE_WORKPLACES_PATH } from "./paths";

interface FavoriteWorkplacesModalRoutesProps {
  baseNavigationPath: string;
}

export function FavoriteWorkplacesModalRoutes(props: FavoriteWorkplacesModalRoutesProps) {
  const { baseNavigationPath } = props;
  const location = useLocation();

  // Generate modal key to prevent unmounting when nested modal is opened
  const modalKey = matchPath(location.pathname, {
    path: `${baseNavigationPath}/${SHIFT_DISCOVERY_FAVORITE_WORKPLACES_PATH}`,
  })
    ? SHIFT_DISCOVERY_FAVORITE_WORKPLACES_PATH
    : undefined;

  return (
    <ModalTransitionSwitch modalKey={modalKey}>
      <ModalRoute
        allowNestedPaths
        closeModalPath={baseNavigationPath}
        path={`${baseNavigationPath}/${SHIFT_DISCOVERY_FAVORITE_WORKPLACES_PATH}`}
        render={({ modalState }) => {
          return <ShiftDiscoveryFavoriteWorkplacesModal modalState={modalState} />;
        }}
      />
    </ModalTransitionSwitch>
  );
}
